export default __webpack_public_path__ + "static/media/S-022.0209a862.png";